import { Component, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class IconComponent {
  @Input() icon: string;
  @Input() iconCssClass: string;

  constructor() { }

  iconFromSpriteOrFont(): boolean {
    if (!this.icon) {
      return false;
    }
    return !this.icon.endsWith('.svg');
  }

  iconlocation(): string {
    return '/assets/icons/ols/' + this.icon;
  }

  geefClassSprite(): string {
    if (this.icon && this.icon.indexOf('sprite') > -1) {
      return this.icon + '-zwart ' + this.icon + '-size';
    }
    return this.icon;
  }

  geefIconCssClass(): string {
    if (this.icon && (this.icon.indexOf('.') > -1 || this.icon.indexOf('sprite') > -1)) {
      return this.iconCssClass;
    }
    return '';
  }
}
